import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AuthService from '../Services/auth.service';
import Accordion2 from '../components/Accordion2/accordion2';
import WeekService from '../Services/week.service';

const Wodiary=()=>{
    //var number=[1,2,3,4,5,6,7];
    var day=["Lunedì", "Martedì","Mercoledì", "Giovedì", "Venerdì", "Sabato", "Domenica"];
    var weeks = [];
    var weekselected = [];
    var currentUserweeks = [];
    const [selweek, setselweek]= useState("");
    //for(var i=0;i<15;i++){weeks.push(i+1)}

    const [file, setfile] = useState([]);
    /*useEffect(() => {
        axios.get('https://dacmethod.herokuapp.com/api/findweek').then(res=> setfile(res.data));
    }, []);
    console.log(file);*/
    
    useEffect(() => {
        WeekService.getweek().then(
          (response) => {
            setfile(response.data);
          },
          (error) => {
            const _content =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
    
            setfile(_content);
          }
        );
      }, []);



    const currentuser=AuthService.getCurrentUser();

    const caricaweek=()=>{
        
        //console.log(currentuser.usercode)
        
        for(var i=0;i<file.length;i++) {
            var fileone = file[i];
            console.log(fileone.usercode)
            if(fileone.usercode == currentuser.usercode) {
                currentUserweeks.push(fileone);
            }
        };
        
        
        for(var m=0;m<currentUserweeks.length;m++){
            weeks.push(<option value={currentUserweeks[m].userweek}>{currentUserweeks[m].userweek}</option>)
        }    
    }
    
    caricaweek();
    console.log(selweek)

    if(selweek==""){
        weekselected.push("-","-","-","-","-","-","-")
    }    
    if(selweek!=""){
        for(var i=0; i<currentUserweeks.length;i++){
            var cuwe=currentUserweeks[i];
            if(selweek==cuwe.userweek){
                weekselected.push(cuwe.weekday1, cuwe.weekday2, cuwe.weekday3, cuwe.weekday4, cuwe.weekday5, cuwe.weekday6, cuwe.weekday7);
                //console.log(weekselected)
            }
        }
    }
    
    return(
        <div>
            <h3>DIARIO ALLENAMENTO</h3>
            <p></p>
            <label>Seleziona settimana:</label>
            <select onChange={event => setselweek(event.target.value)} defaultValue={'00'}>
                <option value="00" disabled>Settimana...</option> 
                {weeks}
            </select>
            <p>{}</p>
            
            {day.map((item, key)=>(<Accordion2 title={item} content={weekselected[key]}/>))}
            
            
        </div>
    )
}
export default Wodiary;